import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function Search({ width = 25, height = 25, color, ...props }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M13.2975 7.1475C13.2975 8.55926 12.8391 9.86336 12.067 10.9214L15.9616 14.8183C16.3461 15.2028 16.3461 15.8272 15.9616 16.2117C15.5771 16.5961 14.9526 16.5961 14.568 16.2117L10.6734 12.3147C9.61514 13.0898 8.31078 13.545 6.89875 13.545C3.36406 13.545 0.5 10.6815 0.5 7.1475C0.5 3.6135 3.36406 0.75 6.89875 0.75C10.4334 0.75 13.2975 3.6135 13.2975 7.1475ZM6.89875 11.5765C9.34443 11.5765 11.3287 9.5927 11.3287 7.1475C11.3287 4.7023 9.34443 2.71846 6.89875 2.71846C4.45307 2.71846 2.46885 4.7023 2.46885 7.1475C2.46885 9.5927 4.45307 11.5765 6.89875 11.5765Z'
        fill={color || theme.colors.gray800}
      />
    </svg>
  );
}
